import { useQuery } from '@tanstack/react-query';
import { driveApi } from '../api/drive-api';

export const useFolderContents = (folderId: string) => {
  return useQuery({
    queryKey: ['drive-folder', folderId],
    queryFn: () => driveApi.listFolder(folderId),
    staleTime: 0,
  });
};

export const useFilePreview = (fileId: string) => {
  return useQuery({
    queryKey: ['drive-file-preview', fileId],
    queryFn: () => driveApi.getPreview(fileId),
    enabled: !!fileId,
    staleTime: 30 * 1000,
  });
};
